// src/footerConfigs.js

export const footerConfigs = {
  "bheema": {
  brandName: "S.S.H ENG MED School,Chadchan",
    contact: "+91 9035393037,8867669037 | cdnshankar@gmail.com",
    socialLinks: {
      instagram: "https://www.instagram.com/shree_ssh/",
      whatsapp:   "https://wa.me/yourwhatsapplink",
      youtube:    "https://www.youtube.com/",
      facebook:   "https://www.facebook.com/",
      twitter:    "https://twitter.com"
    }
  },

  "acmeCorp": {
    brandName: "ACME Corporation",
    contact: "1800-ACME | support@acme.com",
    socialLinks: {
      instagram: "https://instagram.com/acmecorp",
      whatsapp:   "",
      youtube:    "https://youtube.com/acmecorp",
      facebook:   "https://facebook.com/acmecorp",
      twitter:    "https://twitter.com/acmecorp"
    }
  }

  // add more customer configs here...
};
